<div class="faq-wrapper d-flex justify-content-center">
  <div class="parallax-left">
    <img [src]="primaryParallaxImage1" class="parallax-left parallax-el-1"/>
    <img [src]="'https://www.flosports.tv/wp-content/themes/flosports/resources/images/parallax-2-gray.svg'" class="parallax-left parallax-el-2"/>
  </div>
  <div class="parallax-right">
    <img [src]="primaryParallaxImage2"/>
  </div>
  <div class="faq-content d-flex flex-column container">
    <h2 class="faq-header">{{ header }}</h2>
    <div class="accordion">
      <flo-faq-question
        *ngFor="let data of faqData; trackBy: trackByFAQ"
        [question]="data.question"
      >
        <div answer [innerHtml]="data.answer | floSanitizeHtml"> </div>
      </flo-faq-question>
    </div>  
  </div>
</div>